<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 60px;
        "
        v-if="meetingInfo"
      >
        <div class="popup-title">녹화 상세정보</div>
        <!-- <div style="display: flex; flex-direction: row; align-items:center;">
          <img
            v-if="
              meeting.creator.email === $store.state.user.email &&
                meeting.status === 's'
            "
            @click="openDeleteConfirmDialog('close')"
            src="../../../src/images/button/closevideo.png"
            style="width:26px; height: 26px; margin-right:10px; cursor: pointer;"
          />
          <img
            v-if="meeting.creator.email === $store.state.user.email"
            @click="openDeleteConfirmDialog('del')"
            src="../../../src/images/button/delBtn.png"
            style="margin-right:20px; cursor: pointer; width: 26px;"
          />
        </div> -->
      </div>
      <div
        class="dialog-body detailTable"
        v-if="meetingInfo"
        style="margin-top: 0"
      >
        <table>
          <colgroup>
            <col style="width: 120px" />
            <col style="width: 450px" />
          </colgroup>
          <tbody>
            <tr>
              <th>
                <span>회의 제목</span>
              </th>
              <td class="name">
                {{ meetingInfo.title }}
              </td>
            </tr>
            <tr>
              <th>
                <span>녹화 파일 리스트</span>
              </th>
              <td>
                <ul
                  v-for="(record, index) in recordList"
                  v-bind:item="record"
                  v-bind:index="index"
                  v-bind:key="record.fileName"
                >
                  <li style="align-items: center; margin-bottom: 5px;">
                    <div style="display: flex; align-items: center;">
                      <div>
                        <div>{{ record.fileName }}</div>
                        <div style="font-size: 11px;">{{ getDisplayStatus(record) }}</div>
                      </div>
                      
                      <div style="margin-left: 10px;">
                        <button
                          :disabled="record.status === 'p'"
                          class="btnPrimary"
                          @click="downloadRec(record)"
                        >
                          다운로드
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btnArea">
        <button class="btnPrimary" @click="closeDialog">완료</button>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';
import moment from 'moment';
import BaseModal from '@/components/popup/BaseModal';

export default {
  components: {
    BaseModal: BaseModal,
  },
  props: ['dialog', 'meetingInfo', 'isAdmin', 'closeDialog'],
  data() {
    return {
      recordList: [],
    };
  },
  computed: {},
  watch: {
    dialog: {
      async handler(val) {
        if (val) {
          await this.init();
        }
      },
    },
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    async init() {
      // 레코드 정보 가져오기
      this.$http
        .get(`/api/v1/meetings/recordlist/${this.meetingInfo._id}`, {
          params: {
            userId: this.$store.state.user.empNum,
          },
        })
        .then((response) => {
          this.recordList = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDisplayStatus(record) {
      switch (record.status) {
        case 'p':
          return '다운로드 중';
        case 'a':
          return `완료(${moment(record.lastDownDtime).format(
            'YYYY-MM-DD HH:mm:ss'
          )})`;
        case 'e':
          return `에러(${moment(record.lastDownDtime).format(
            'YYYY-MM-DD HH:mm:ss'
          )})`;
        default:
          return record.status;
      }
    },
    downloadRec(record) {
      this.$http
        .post(`/api/v1/meetings/record/download`, {
          userId: this.$store.state.user.empNum,
          fileName: record.fileName,
          meetingId: this.meetingInfo._id,
        })
        .then((response) => {
          alert(`문서중앙화 서버에 파일 다운로드를 시작합니다.`);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.popup_top {
  padding-left: 0;
  background-color: #efeefd;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.popup-title {
  line-height: 77px;
  color: #333333;
  font-weight: 700;
  font-size: 16px;
  padding-left: 24px;
}
.dataTable table td:nth-child(odd) {
  background: #fff;
  width: 145px;
  padding-left: 40px;
}

.dataTable table.info td:nth-child(odd) {
  background: #fff;
  padding-left: 0px;
}

.dataTable table.detail td:nth-child(2n) {
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  color: #333;
  vertical-align: top;
}

.dataTable table td {
  height: 66px;
  background: #fff;
  letter-spacing: -2px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #333;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
}

.v-dialog {
  max-height: none !important;
}

.btnArea {
  display: flex;
  justify-content: center;
}

.invite-btn {
  background-color: #604af3;
  color: white;
  width: 130px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/RecInfoDialog.vue